<template>
  <div class="dropdown dropdown-notifications w500">
    <a
      href="#"
      class="btn btn-icon btn-rounded btn-flush-dark flush-soft-hover dropdown-toggle no-caret"
      data-bs-toggle="dropdown"
      data-dropdown-animation
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span class="icon">
        <span class="position-relative notif-bell-wrap">
          <span class="feather-icon">
            <i class="bx bx-bell bx-tada fs-4"></i>
          </span>
          <span v-if="unreadCount > 0" class="notif-count-badge">
            {{ unreadCount > 99 ? "99+" : unreadCount }}
          </span>
        </span>
      </span>
    </a>
    <div class="dropdown-menu dropdown-menu-end p-0 w500">
      <h6 class="dropdown-header px-4 fs-6">
        Notifications
        <a
          href="#"
          class="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover"
        >
          <span class="icon"
            ><span class="feather-icon"><i class="bx bx-cog"></i></span
          ></span>
        </a>
      </h6>

      <div
        v-if="notificationsHeader.loading"
        class="more-notif-spinner w-notif-header"
      >
        <div class="spinner-border text-primary" role="status"></div>
      </div>

      <div data-simplebar class="dropdown-body p-2" v-else>
        <NuxtLink
          to=""
          class="dropdown-item"
          :class="{ 'notif-unread': !notif.seen }"
          v-for="(notif, index) in notificationsHeader.data"
          :key="notif._id || index"
          @click="handleClick(notif)"
        >
          <div class="media">
            <div class="media-head">
              <div class="avatar avatar-rounded avatar-sm">
                <img
                  src="~/assets/images/avatar2.jpg"
                  alt="user"
                  class="avatar-img"
                />
              </div>
            </div>
            <div class="media-body">
              <div>
                <div class="notifications-text">
                  {{ notif.message }}
                </div>
                <div class="notifications-info">
                  <span class="badge badge-soft-success">{{
                    getCustomLabel(notif.label)
                  }}</span>
                  <div class="notifications-time">
                    {{ formatDateTime(notif.createdAt) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </NuxtLink>

        <div
          v-if="!notificationsHeader.data.length"
          class="w-empty-data-notif w-empty-header-notif"
        >
          <img src="~/assets/icons/empty-data.svg" alt="" />
          <span>Vous n'avez actuellement aucune notification.</span>
        </div>
      </div>
      <div class="dropdown-footer">
        <NuxtLink to="/notifications"
          ><u>Voir tous les notifications</u></NuxtLink
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import dayjs from "dayjs";
import { storeToRefs } from "pinia";
import { useNotificationStore } from "~/store/notifications/notificationStore";
import { urls } from "~/store/notifications/urls";

const { udpateNotification } = useNotificationStore();
const { notificationsHeader } = storeToRefs(useNotificationStore());

const unreadCount = computed(() => {
  return Number(notificationsHeader.value.totalUnSeen) || 0;
});

const formatDateTime = (dateTime: any) => {
  return dayjs(dateTime).format("DD MMM YYYY à HH:mm");
};

const handleClick = async (item: any) => {
  const url = urls.find((url) => url.label === item.label);
  await udpateNotification(item._id);

  let finalUrl = url?.url;

  if (url?.tab) {
    const separator = finalUrl?.includes("?") ? "&" : "?";
    finalUrl = `${finalUrl}${separator}tab=${url.tab}`;
  }

  const caracteristique =
    item.caracteristique && typeof item.caracteristique === "object"
      ? item.caracteristique
      : null;

  if (caracteristique?.dateDebut) {
    const dateDebut = new Date(caracteristique.dateDebut);
    const year = dateDebut.getFullYear();
    const month = dateDebut.getMonth() + 1;

    const separator = finalUrl?.includes("?") ? "&" : "?";
    finalUrl = `${finalUrl}${separator}year=${year}&month=${month}`;
  }

  navigateTo(finalUrl);
};

const getCustomLabel = (labe: string) => {
  try {
    const url = urls.find((url) => url.label === labe);

    return url?.name;
  } catch (error) {
    return "";
  }
};
</script>
<style lang="scss" scoped>
.dropdown-notifications {
  :deep(.btn-icon) {
    overflow: visible;
  }
}

.notif-bell-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
}

.notif-count-badge {
  position: absolute;
  top: -4px;
  right: -10px;
  z-index: 2;
  min-width: 1.15rem;
  height: 1.15rem;
  padding: 0 0.3rem;
  font-size: 0.65rem;
  font-weight: 600;
  line-height: 1.15rem;
  text-align: center;
  color: #fff;
  background-color: #dc3545;
  border-radius: 999px;
  border: 2px solid #fff;
  box-sizing: border-box;
}

.notif-unread {
  background-color: rgba(13, 110, 253, 0.08);
  border-radius: 0;

  &:hover,
  &:focus {
    background-color: rgba(13, 110, 253, 0.14);
  }
}

.more-notif-spinner {
  display: flex;
  justify-content: center;
  padding: 50px;
}

.w-notif-header {
  border: 1px solid;
}

.w-empty-header-notif {
  margin-top: 50px;

  img {
    width: 9rem;
    height: 9rem;
  }
}

.simplebar-content {
  height: 300px !important;
}
</style>
